import { render, staticRenderFns } from "./ServiceTutorEditPicture.vue?vue&type=template&id=4d5040fb&scoped=true&"
import script from "./ServiceTutorEditPicture.vue?vue&type=script&lang=js&"
export * from "./ServiceTutorEditPicture.vue?vue&type=script&lang=js&"
import style0 from "./ServiceTutorEditPicture.vue?vue&type=style&index=0&id=4d5040fb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d5040fb",
  null
  
)

export default component.exports